<template>
  <div
    v-if="
      auth.user.selectedAccess.roleLevel > 1 ||
        (chain && auth.user.selectedAccess.chain_id == chain.id)
    "
  >
    <loading-spinner v-if="!chain" />
    <app-header
      v-if="chain"
      :title="chain.name"
      :subtitle="
        $store.getters['translations/getLabel']('CHAIN') + ' #' + chain.id
      "
    >
      <template #col-right>
        <div
          v-if="
            auth.user.selectedAccess.roleLevel >= 1 &&
              auth.user.selectedAccess.can_modify_settings
          "
        >
          <b-button
            v-router-link="{ name: 'chain-editor', query: { id: chain.id } }"
            variant="primary"
          >
            <i class="fa fa-pencil-square-o" style="font-size:20px" />&nbsp;
            <span v-label-key="'EDIT_CHAIN'">Edit Chain</span>
          </b-button>
        </div>
      </template>
    </app-header>

    <b-container>
      <b-nav tabs class="mb-3">
        <b-nav-item :to="{ name: 'chain-reports-tab' }">
          <span v-label-key="'REPORTS'">Reports</span>
        </b-nav-item>
        <b-nav-item :to="{ name: 'chain-transactions-tab' }">
          <span v-label-key="'TRANSACTIONS'">Transactions</span>
        </b-nav-item>
        <b-nav-item :to="{ name: 'chain-stores-tab' }">
          <span v-label-key="'STORES'">Stores</span> ({{
            summary?.storeCount || 0
          }})
        </b-nav-item>
        <b-nav-item
          v-if="auth.user.selectedAccess.roleLevel > 2"
          :to="{ name: 'chain-users-tab' }"
        >
          <span v-label-key="'USERS'">Users</span> ({{
            summary?.userCount || 0
          }})
        </b-nav-item>
        <b-nav-item
          v-if="auth.user.selectedAccess.roleLevel > 3"
          :to="{ name: 'chain-template-types-tab' }"
        >
          <span v-label-key="'TEMPLATE_TYPES'">Template Types</span>
        </b-nav-item>
        <b-nav-item
          v-if="
            auth.user.selectedAccess.roleLevel > 3 &&
              getShowTab('warranty_settings')
          "
          :to="{ name: 'chain-extended-warranty-tab' }"
        >
          <span v-label-key="'WARRANY_SETTINGS'">Warranty Settings</span>
        </b-nav-item>
        <b-nav-item
          v-if="getShowTab('lifetime_warranty')"
          :to="{ name: 'chain-lifetime-warranty-tab' }"
        >
          <span v-label-key="'LIFETIME_WARRANTY'">Lifetime Warranty</span>
        </b-nav-item>
        <b-nav-item :to="{ name: 'chain-four-seasons-tab' }">
          <span v-label-key="'FOUR_SEASONS'">Four Seasons</span>
        </b-nav-item>
        <b-nav-item :to="{ name: 'chain-about-tab' }">
          <span v-label-key="'ABOUT'">About</span>
        </b-nav-item>
        <b-nav-item
          v-if="auth.user.selectedAccess.roleLevel > 3"
          :to="{ name: 'chain-store-settings-tab' }"
        >
          <span v-label-key="'STORE_SETTINGS'">Store Settings</span>
        </b-nav-item>
        <b-nav-item
          v-if="auth.user.selectedAccess.can_manage_staff"
          :to="{ name: 'chain-staff-tab' }"
        >
          <span v-label-key="'STAFF'">Staff</span> ({{ summary?.retailStaffCount || 0 }})
        </b-nav-item>
      </b-nav>
      <div>
        <router-view v-if="chain"
            :chain_id="chain?.id"
            :subdistributor_id="chain?.subdistributor_id"
            :distributor_id="chain?.distributor_id"
          />
      </div>
    </b-container>
  </div>
</template>
<script>
import $auth from '@/services/auth';
import $api from '@/services/api';
import { mapGetters } from 'vuex';
import LoadingSpinner from '@/components/LoadingSpinner';
import AppHeader from '@/components/AppHeader';

export default {
  components: {
    LoadingSpinner,
    AppHeader,
  },

  data() {
    return {
      auth: $auth,
      chain: null,
      summary: null,
    };
  },

  computed: {
    ...mapGetters('config', ['getShowTab']),
  },

  created() {
    this.refreshData();
  },

  methods: {
    refreshData() {
      this.$store.commit('global/clearAllState');

      $api.get(`/v1/dashboard/chains/${this.$route.params.id}`).then(chain => {
        this.chain = chain;

        $api
          .get(`/v1/dashboard/chains/summary?chain_id=${chain.id}&subdistributor_id=${chain.subdistributor_id}&distributor_id=${chain.distributor_id}`)
          .then((response) => {
            this.summary = response;
          });


        // const payload = {
        //   chain_id: chain.id,
        //   subdistributor_id: chain.subdistributor_id,
        //   distributor_id: chain.distributor_id,
        // };
        // this.$store.dispatch('global/getStores', payload);
        // this.$store.dispatch('global/getUsers', { chain_id: chain.id });
      });
    },
  },
};
</script>
<style scoped>
a {
  color: black;
}
</style>
